export default "__VITE_ASSET__BgXamx6j__"